import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoggerService } from './shared/sdk';

@Injectable({
  providedIn: 'root',
})
export class SDKService {
  private _isSDK = false;
  private isSDKSource = new BehaviorSubject<boolean>(this._isSDK);
  isSDK$ = this.isSDKSource.asObservable();
  private stopListening$ = new Subject<void>();

  private _isHeadMenuHidden = false;
  private isHeadMenuHiddenSource = new BehaviorSubject<boolean>(
    this._isHeadMenuHidden,
  );
  isHeadMenuHidden$ = this.isHeadMenuHiddenSource.asObservable();

  private _isSideMenuShown = true;
  private isSideMenuShownSource = new BehaviorSubject<boolean>(
    this._isSideMenuShown,
  );
  isSideMenuShown$ = this.isSideMenuShownSource.asObservable();

  constructor(private logger: LoggerService, private route: ActivatedRoute) {
    this.checkSDKParam();
    this.listenForHeight();
  }

  sendMessage(type: string, payload: any = {}): void {
    if (this._isSDK) {
      this.postMessage(type, payload);
    }
  }

  private checkSDKParam(): void {
    this.route.queryParamMap
      .pipe(takeUntil(this.stopListening$))
      .subscribe((params) => {
        if (params.get('sdk') === 'true') {
          this._isSDK = true;
          this.isSDKSource.next(this._isSDK);
          this.stopListening$.next();
          this.postDocumentHeight();
        }

        // Head menu hide
        if (this._isSDK && params.get('hideHeadMenu') === 'true') {
          this._isHeadMenuHidden = true;
          this.isHeadMenuHiddenSource.next(this._isHeadMenuHidden);
        }

        // Side menu show
        if (this._isSDK && params.get('showSideMenu') !== 'true') {
          this._isSideMenuShown = false;
          this.isSideMenuShownSource.next(this._isSideMenuShown);
        }
      });
  }

  private listenForHeight(): void {
    window.addEventListener('resize', () => {
      this.postDocumentHeight();
    });
  }

  private postDocumentHeight(): void {
    if (!document.body) return;
    const height = document.body.scrollHeight;
    this.logger.log('postDocumentHeight', height);
    this.postMessage('DOCUMENT_HEIGHT', { height });
  }

  private postMessage(type: string, payload: any): void {
    window.parent.postMessage({ type, payload }, '*');
  }
}
